import { FC, ReactNode } from 'react'
import IconPointA from 'assets/point-a.svg?react'
import IconPointB from 'assets/point-b.svg?react'
import { Search } from 'components/extend'

import s from './OrderFilterSearchField.module.less'

export interface OrderFilterSearchFieldProps {
  onChange: (value: string) => void
  type: 'departure' | 'destination'
  value: string
  postfix?: ReactNode
}

export const OrderFilterSearchField: FC<OrderFilterSearchFieldProps> = ({ type, value, onChange, postfix }) => (
  <Search
    isOrder
    className={s.search}
    handleSearch={onChange}
    placeholder={type === 'departure' ? 'Откуда' : 'Куда'}
    postfix={postfix}
    searchQuery={value || ''}
    iconPoint={
      type === 'departure' ? (
        <IconPointA className={s.iconPoint} size="sm" />
      ) : (
        <IconPointB className={s.iconPoint} size="sm" />
      )
    }
  />
)
